/** Política de cierre por inactividad (solo UI web; no afecta workers SAT). */

export const SESSION_IDLE_MS_STRICT = 30 * 60 * 1000;
export const SESSION_IDLE_MS_REMEMBER = 90 * 60 * 1000;
export const SESSION_IDLE_WARN_MS = 5 * 60 * 1000;

/** Timestamp compartido entre pestañas (visor principal + ventana BNT Asistente). */
export const SESSION_ACTIVITY_STORAGE_KEY = "visor:session_last_activity";
export const SESSION_ACTIVITY_CHANNEL = "visor:session-activity";

/** Mínimo entre eventos mousemove que cuentan como actividad (evita spam). */
export const SESSION_IDLE_MOUSEMOVE_THROTTLE_MS = 30 * 1000;

export function resolveSessionIdleMs(remember) {
  return remember ? SESSION_IDLE_MS_REMEMBER : SESSION_IDLE_MS_STRICT;
}

export function isAssistantSessionPath(pathname = "") {
  const path = String(pathname || "").split("?")[0];
  return path === "/asistente" || path.startsWith("/asistente/");
}

export function touchSharedSessionActivity(at = Date.now()) {
  const ts = Number(at) || Date.now();
  if (typeof window === "undefined") return ts;
  try {
    localStorage.setItem(SESSION_ACTIVITY_STORAGE_KEY, String(ts));
  } catch {
    /* ignore quota / private mode */
  }
  try {
    if (typeof BroadcastChannel !== "undefined") {
      const channel = new BroadcastChannel(SESSION_ACTIVITY_CHANNEL);
      channel.postMessage({ ts });
      channel.close();
    }
  } catch {
    /* ignore */
  }
  return ts;
}

export function readSharedSessionActivity() {
  if (typeof window === "undefined") return 0;
  try {
    const raw = localStorage.getItem(SESSION_ACTIVITY_STORAGE_KEY);
    const ts = raw ? Number(raw) : 0;
    return Number.isFinite(ts) && ts > 0 ? ts : 0;
  } catch {
    return 0;
  }
}

export function resolveEffectiveLastActivity(localTs, sharedTs = readSharedSessionActivity()) {
  const local = Number(localTs) || 0;
  const shared = Number(sharedTs) || 0;
  return Math.max(local, shared);
}

const ACTIVITY_EVENTS = ["mousedown", "keydown", "touchstart", "scroll", "click", "mousemove"];

export function bindSessionActivityListeners(onActivity) {
  let lastMoveAt = -SESSION_IDLE_MOUSEMOVE_THROTTLE_MS;
  const handler = (event) => {
    if (event.type === "mousemove") {
      const now = Date.now();
      if (now - lastMoveAt < SESSION_IDLE_MOUSEMOVE_THROTTLE_MS) return;
      lastMoveAt = now;
    }
    onActivity();
  };
  ACTIVITY_EVENTS.forEach((ev) => window.addEventListener(ev, handler, { passive: true }));
  return () => ACTIVITY_EVENTS.forEach((ev) => window.removeEventListener(ev, handler));
}

/** Recibe actividad registrado otras pestañas (storage + BroadcastChannel). */
export function bindSharedSessionActivitySync(onRemoteActivity) {
  if (typeof window === "undefined") return () => {};

  const onStorage = (event) => {
    if (event.key !== SESSION_ACTIVITY_STORAGE_KEY || !event.newValue) return;
    const ts = Number(event.newValue);
    if (Number.isFinite(ts) && ts > 0) onRemoteActivity(ts);
  };

  window.addEventListener("storage", onStorage);

  let channel = null;
  try {
    if (typeof BroadcastChannel !== "undefined") {
      channel = new BroadcastChannel(SESSION_ACTIVITY_CHANNEL);
      channel.onmessage = (event) => {
        const ts = event?.data?.ts;
        if (typeof ts === "number" && ts > 0) onRemoteActivity(ts);
      };
    }
  } catch {
    channel = null;
  }

  return () => {
    window.removeEventListener("storage", onStorage);
    if (channel) {
      try {
        channel.close();
      } catch {
        /* ignore */
      }
    }
  };
}
